import { useState } from "react";
import { post, get } from './fetch';
import { Driver } from "./types";

export const useSocial = () => {
  const [url, setUrl] = useState('')
  const [state, setState] = useState('')

  const getSocial = async(driver: Driver, scene: string) => {
    const res:any = await get('/api/account/social/auth', {
      driver,
      scene
    })
    if(res?.data.auth_url) {
      setUrl(res.data.auth_url)
      setState(res.data.state)
    }
  }

  const checkAuth = async(driver: Driver, scene: string) => {
    const res:any = await post('/api/account/social/check-auth', {
      driver,
      scene,
      state
    })
    return res
  }

  return {
    url,
    state,
    getSocial,
    checkAuth
  }
}

export const useLogin = () => {

  const loginSocial = async ({type, code, onSuccess}) => {
    const res: any = await post('/api/account/third-login', {
      driver: type,
      code
    }, {
      'x-mock-disable-signature': true
    })
    if(res.data.token){
      onSuccess(res.data);
    }
    return res
  }

  return {
    loginSocial
  }
}